var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M488.4,242.5c2.2-7.5,3.4-15.2,3.4-23c0-17.6-5.8-34.5-16.2-48.3c2.2-7.5,3.4-15.2,3.4-23c0-17.6-5.8-34.5-16.2-48.3 c2.2-7.5,3.4-15.2,3.4-23c0-32.1-19.1-61-48.7-73.6C412.1,1.1,406.5,0,400.9,0H27.3C16.3,0,7.4,8.9,7.4,19.9v226.2 c0,11,8.9,19.9,19.9,19.9h80.4L161,459.1c8.6,31.1,37.2,52.9,69.5,52.9c18.5,0,35.7-7.3,48.4-20.8c12.7-13.4,19.3-30.9,18.3-49.3 l-3.7-76.4h149.1c7.5,0,14.9-2,21.3-5.8c25.1-14.6,40.7-41.1,40.7-69C504.6,273.2,498.8,256.3,488.4,242.5z M52.2,221.2V44.7h50.3 v176.5H52.2z M441.9,320.8H246.6l6,123.3c0.4,7.4-2.9,14.4-9.1,19c-3.8,2.8-8.5,4.2-13.1,4.2c-12.2-0.1-22.9-8.3-26.2-20.1 l-61.8-224V44.7h258.1c12.7,5.7,20.9,18.3,20.9,32.2c0,6-1.4,11.7-4.3,17l-8.6,15.8l13.6,11.8c7.8,6.7,12.2,16.5,12.2,26.7 c0,6-1.4,11.7-4.3,17l-8.6,15.8l13.6,11.8c7.8,6.7,12.2,16.5,12.2,26.7c0,6-1.4,11.7-4.3,17l-8.7,15.8l13.6,11.8 c7.8,6.7,12.2,16.5,12.2,26.7C459.8,302.6,453,314.1,441.9,320.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.16a4d54b.svg";
export { ForwardRef as ReactComponent };